export default __webpack_public_path__ + "79cd20b2ea327b5f282931e93d8581f0.png";